import React, { useState } from "react";
import SpHeader from "../../../Components/mainHeader/SpHeader";
import SiteHeaderDropdown from "../SiteHeaderDropdown";

import styles from '../SitePerformance.module.css';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';

import ReactECharts from 'echarts-for-react';
import SitePerfPowerSrcChart from "../../../screensUi/SitePerfPowerSrcChart";
import AmTabsHeader from "../../../Components/TopTabsHeader/AmTabsHeader";
import { performanceMenu } from "./SpPerformanceMenu";
import ApplyFilterHeader from "../../../Components/ApplyFilterHeader";



function SitesPerformance() {
    const pageNo = 0;
    const breadcrumbs = [
        { label: 'Sites', link: '' },
        { label: 'Performance', link: '/SitesPerformance' },
        { label: 'Site Summary', link: '/SitesPerformance' },
    ];

    const summaryObj = {
        minimize: 'Minimise',
        otherName: "Summary",
        minUrl: '/SitesPerformance',
        otherUrl: '/SingleSiteSummary',
    }


    // chart 

    const sp_calcTargets_data = {
        title: {
            text: 'Hours',
            show: false,
            top: 20,
            textStyle: {
                fontSize: 14,
                fontWeight: '500',
                fontFamily: 'Roboto, sans-serif',
            },
        },

        tooltip: {
            trigger: 'axis'
        },
        legend: {
            bottom: '0px',
            left: 'center',
            show: true,
            data: ['Solar', 'Grid', 'Genset', 'Battery'],
            fill: 'orange',
        },

        grid: {
            top: '30px',
            left: '0px',
            right: '10px',
            bottom: '30px',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                boundaryGap: true,
                data: ['Target', 'Actual'],
                splitLine: {
                    show: false,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],
        yAxis: [
            {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: '#F0F0F0'
                    }
                },
            }
        ],
        series: [
            {
                name: 'Solar',
                type: 'bar',
                stack: 'Hours',
                smooth: true,
                color: ['#EEA900'],
                data: [40, 90]
            },
            {
                name: 'Grid',
                type: 'bar',
                stack: 'Hours', // Use the same stack name for both series
                smooth: true,
                color: ['#7243D0'],
                data: [70, 40]
            },
            {
                name: 'Genset',
                type: 'bar',
                stack: 'Hours', // Use the same stack name for both series
                smooth: true,
                color: ['#32864B'],
                data: [90, 60]
            },
            {
                name: 'Battery',
                type: 'bar',
                stack: 'Hours',
                smooth: true,
                color: ['#0058FF'],
                data: [250, 120]
            },
        ]
    };

    // right chart functions 

    const powerSourcesData = [
        {
            "id": 0,
            "title": 'Solar Performance',
            "titlebtn": 'Average',
            "titlebtnBgClr": '#F57F3C',
            "titlebtnClr": '#FFF',
            "boxClass": 'pws_enabled',
            "colorClass": 'pws_red',
            "actualTitle": 'Actual',
            "actualValue": '72',
            "actualType": 'kWh',
            "actualPercent": '-37%',
            "actualColor": '#F1B400',
            "actualData": 100,
            "targetTitle": 'Target',
            "targetValue": '114',
            "targetType": 'kWh',
            "targetColor": '#FCF0CC',
            "targetData": 58,
            "icon": `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.25 4.87512V3.00012H8V4.87512H4.25ZM3 28.0001H14.5625V22.6876H4.0625L3 28.0001ZM7.8125 11.7501L6.46875 10.4376L9.125 7.78137L10.4687 9.09387L7.8125 11.7501ZM4.4375 20.8126H14.5625V15.5001H5.5L4.4375 20.8126ZM15.5 8.62512C13.9583 8.62512 12.6562 8.07825 11.5937 6.9845C10.5312 5.89075 9.95833 4.56262 9.875 3.00012H21.125C21.0417 4.56262 20.4687 5.89075 19.4062 6.9845C18.3437 8.07825 17.0417 8.62512 15.5 8.62512ZM14.5625 14.2501V10.5001H16.4375V14.2501H14.5625ZM16.4375 28.0001H28L26.9375 22.6876H16.4375V28.0001ZM16.4375 20.8126H26.5625L25.5 15.5001H16.4375V20.8126ZM23.1875 11.7189L20.5312 9.06262L21.8437 7.75012L24.5312 10.3751L23.1875 11.7189ZM23 4.87512V3.00012H26.75V4.87512H23Z" fill="white"/><mask id="mask0_3092_22910" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="31" height="31"> <rect x="0.5" y="0.500366" width="30" height="30" fill="white"/></mask> <g mask="url(#mask0_3092_22910)"></g> </svg>`
        },
        {
            "id": 1,
            "title": 'Grid Performance',
            "titlebtn": 'Good',
            "titlebtnBgClr": '#00B53D',
            "titlebtnClr": '#FFF',
            "boxClass": 'pws_enabled',
            "colorClass": 'pws_red',
            "actualTitle": 'Actual',
            "actualValue": '166',
            "actualType": 'kWh',
            "actualPercent": '-17%',
            "actualColor": '#7243D0',
            "actualData": 100,
            "targetTitle": 'Target',
            "targetValue": '200',
            "targetType": 'kWh',
            "targetColor": '#E3D9F6',
            "targetData": 78,
            "icon": `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path d="M1.12463 29.6252H29.8746" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /><path d="M10.3809 29.6251L11.7496 0.875122H21.7496L23.1184 29.6251" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M21.6522 0.875122L11.3085 10.1526" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.7496 14.625L11.2983 10.3475" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M11.8472 0.875122L22.1909 10.1526" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /><path d="M16.7496 14.625L22.2009 10.3475" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M29.2272 21.1539C29.2898 21.248 29.3257 21.3573 29.3311 21.4703C29.3365 21.5832 29.3112 21.6955 29.2578 21.7951C29.2045 21.8948 29.1251 21.9781 29.0281 22.0362C28.9311 22.0943 28.8202 22.1251 28.7072 22.1251H4.79216C4.6791 22.1251 4.56818 22.0943 4.47121 22.0362C4.37424 21.9781 4.29484 21.8948 4.24148 21.7951C4.18812 21.6955 4.16279 21.5832 4.16819 21.4703C4.1736 21.3573 4.20953 21.248 4.27216 21.1539L8.43966 14.9039C8.49668 14.8182 8.57398 14.7479 8.6647 14.6993C8.75541 14.6506 8.85673 14.6252 8.95966 14.6251H24.5397C24.6426 14.6252 24.7439 14.6506 24.8346 14.6993C24.9253 14.7479 25.0026 14.8182 25.0597 14.9039L29.2272 21.1539Z" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M11.1259 14.6251L22.9996 22.1251L27.1246 18.0001" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M22.3733 14.6265L10.5008 22.1252L6.37451 17.999" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.99951 0.875122H11.7495" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M21.7496 0.875122H25.4996" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /> <path d="M7.99951 7.125H11.452" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /><path d="M22.0472 7.125H25.4997" stroke="white" strokeWidth="1.71921" strokeLinecap="round" strokeLinejoin="round" /></g></svg>`
        },
        {
            "id": 2,
            "title": 'Genset Performance',
            "titlebtn": 'Good',
            "titlebtnBgClr": '#00B53D',
            "titlebtnClr": '#FFF',
            "boxClass": 'pws_enabled',
            "colorClass": 'pws_green',
            "actualTitle": 'Actual',
            "actualValue": '81',
            "actualType": 'kWh',
            "actualPercent": '-10%',
            "actualColor": '#32864B',
            "actualData": 100,
            "targetTitle": 'Target',
            "targetValue": '90',
            "targetType": 'kWh',
            "targetColor": '#D6E7DB',
            "targetData": 20,
            "icon": `<svg width="31" height="25" viewBox="0 0 31 25" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M30.4988 4.45803C30.4988 3.7171 30.1801 3.40952 29.4129 3.40952C23.4754 3.40952 17.5379 3.40952 11.6012 3.40952H11.2223C11.2223 2.85648 11.2168 2.34587 11.2285 1.83526C11.2301 1.76329 11.2949 1.66631 11.3598 1.62692C11.7629 1.38146 11.9426 1.03297 11.8403 0.655692C11.727 0.238261 11.3918 0.00113638 10.9004 0.00113638C9.35745 -0.000378794 7.81448 -0.000378794 6.27151 0.00113638C5.78166 0.00189397 5.44338 0.240534 5.33088 0.654935C5.22854 1.03146 5.40745 1.38373 5.81213 1.62465C5.86838 1.65798 5.94104 1.72541 5.9426 1.77768C5.95198 2.31405 5.94885 2.85042 5.94885 3.40952C5.58635 3.40952 5.25666 3.40498 4.9262 3.41028C4.3926 3.41937 4.02385 3.77089 4.0176 4.28681C4.00901 4.83606 4.01448 5.38531 4.01448 5.93456C4.01448 6.19593 4.01448 6.45806 4.01448 6.727C3.92151 6.73912 3.86526 6.74821 3.80823 6.75276C2.32698 6.88761 1.09963 7.85202 0.662134 9.23007C0.599634 9.4278 0.55354 9.63008 0.499634 9.83008V17.1597C0.523853 17.231 0.548071 17.3022 0.571509 17.3734C0.810571 18.1082 1.30745 18.5939 2.08166 18.7749C2.35276 18.8378 2.64338 18.8302 2.92541 18.8378C3.28166 18.8476 3.63791 18.8401 4.01526 18.8401C4.01526 19.678 4.01135 20.4719 4.01682 21.2659C4.02073 21.7992 4.38713 22.1507 4.93791 22.1598C5.20901 22.1644 5.4801 22.1606 5.74573 22.1606C5.99885 23.9136 6.97463 24.928 8.4512 24.9962C9.1387 25.0281 9.76448 24.8508 10.3153 24.447C11.0918 23.878 11.4395 23.0977 11.4707 22.1742H23.0285C23.3262 23.9712 24.2903 24.9538 25.7895 24.9985C26.4785 25.019 27.102 24.8296 27.6434 24.4167C28.3879 23.8492 28.7293 23.0818 28.7535 22.1606C28.9926 22.1606 29.2059 22.1606 29.4192 22.1606C30.1817 22.1598 30.4996 21.8507 30.4996 21.106C30.4988 15.5559 30.4988 10.0066 30.4988 4.45803ZM4.0012 17.1325C3.51448 17.1325 3.05745 17.137 2.59963 17.131C2.31682 17.1272 2.25354 16.9522 2.25432 16.709C2.25979 15.1855 2.25666 13.6612 2.25666 12.1377C2.25666 11.4937 2.24729 10.8506 2.26057 10.2074C2.2801 9.26719 3.10198 8.44976 4.0012 8.47324V17.1325ZM7.71995 1.72541H9.44495V3.39361H7.71995V1.72541ZM9.2387 23.0962C8.88323 23.3432 8.49338 23.3704 8.10823 23.1697C7.7137 22.9644 7.52854 22.6295 7.53088 22.1697H9.68401C9.71526 22.5697 9.55745 22.875 9.2387 23.0962ZM26.5231 23.097C26.1676 23.3432 25.7778 23.3697 25.3926 23.1689C24.9989 22.9629 24.8129 22.6288 24.8168 22.1704H26.9699C27.0004 22.5704 26.8426 22.8757 26.5231 23.097ZM28.7176 20.4356H5.78557V18.7651H28.7176V20.4356ZM28.7254 17.0234H5.79338V5.12622H28.7254V17.0234ZM10.0012 11.7506C10.3606 11.7536 10.7199 11.7513 11.1067 11.7513C11.0668 11.8687 11.0379 11.9574 11.0067 12.0453C10.7957 12.6241 10.5793 13.2006 10.3746 13.7817C10.2035 14.2695 10.4192 14.7317 10.8817 14.8991C11.3449 15.0665 11.8379 14.8529 12.0176 14.3756C12.4153 13.3203 12.8043 12.2619 13.1801 11.199C13.3942 10.5937 12.9934 10.0634 12.334 10.049C11.9934 10.0414 11.652 10.0475 11.2434 10.0475C11.5114 9.45735 11.7598 8.91719 12.0028 8.374C12.2278 7.8702 12.0543 7.37398 11.5895 7.17549C11.1223 6.97625 10.6324 7.18307 10.3996 7.68762C9.97385 8.60961 9.54885 9.53235 9.1301 10.4574C8.81291 11.1536 9.21448 11.7445 10.0012 11.7506ZM18.2559 8.52248C19.5332 8.524 20.8114 8.52324 22.0887 8.52324C23.3957 8.52324 24.7028 8.52476 26.0098 8.52248C26.5817 8.52173 26.9762 8.17551 26.9817 7.67929C26.9871 7.17246 26.5871 6.81943 25.9981 6.81867C23.4137 6.81791 20.8285 6.81791 18.2442 6.81867C17.6551 6.81867 17.2535 7.17019 17.2574 7.6755C17.2614 8.18081 17.6606 8.52173 18.2559 8.52248ZM18.2551 11.9316C19.5426 11.9331 20.8301 11.9324 22.1176 11.9324C23.4145 11.9324 24.7121 11.9339 26.009 11.9316C26.5809 11.9309 26.9762 11.5854 26.9824 11.0892C26.9887 10.5824 26.5879 10.2286 25.9996 10.2278C23.4153 10.2271 20.8301 10.2271 18.2457 10.2278C17.6559 10.2278 17.2551 10.5786 17.2582 11.0839C17.2606 11.5892 17.6606 11.9309 18.2551 11.9316ZM26.0223 13.6377C23.4379 13.6354 20.8528 13.6362 18.2684 13.637C17.6551 13.637 17.2512 13.9839 17.2582 14.4991C17.2653 15.0036 17.6645 15.34 18.2614 15.3408C19.5489 15.3415 20.8363 15.3408 22.1238 15.3408C23.4309 15.3408 24.7379 15.34 26.0449 15.3408C26.4449 15.3408 26.7457 15.1764 26.909 14.8211C27.1762 14.2377 26.7262 13.6385 26.0223 13.6377Z" fill="white"/> </svg> `
        },
        {
            "id": 3,
            "title": 'Battery Performance',
            "titlebtn": 'Good',
            "titlebtnBgClr": '#00B53D',
            "titlebtnClr": '#FFF',
            "boxClass": 'pws_enabled',
            "colorClass": 'pws_red',
            "actualTitle": 'Actual',
            "actualValue": '114',
            "actualType": 'kWh',
            "actualPercent": '-0%',
            "actualColor": '#0058FF',
            "actualData": 100,
            "targetTitle": 'Target',
            "targetValue": '114',
            "targetType": 'kWh',
            "targetColor": '#D0D0D0',
            "targetData": 100,
            "icon": `<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fillRule="evenodd" clipRule="evenodd" d="M21.7503 23.0002H6.75031C5.36906 23.0002 4.25031 21.8815 4.25031 20.5002V10.5002C4.25031 9.11899 5.36906 8.00024 6.75031 8.00024H21.7503C23.1316 8.00024 24.2503 9.11899 24.2503 10.5002V20.5002C24.2503 21.8815 23.1316 23.0002 21.7503 23.0002Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M14.6252 19.2502L16.5002 15.5002H12.0002L13.8752 11.7502" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24.2502 11.7502H25.5177C25.7115 11.7502 25.9027 11.7952 26.0765 11.8827L26.684 12.1865C27.1077 12.3977 27.3752 12.8315 27.3752 13.304V17.6965C27.3752 18.1702 27.1077 18.6027 26.684 18.814L26.0765 19.1177C25.9027 19.2052 25.7115 19.2502 25.5177 19.2502H24.2502" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>  `
        },
    ]

    const [chartData] = useState(powerSourcesData);

    return (
        <div className="sitePerformance_wrapper">
            <SpHeader breadcrumbs={breadcrumbs} summaryObj={summaryObj} exdb='false' isSummaryButton isSiteDropdown={<SiteHeaderDropdown />} />
            <div className="pb-2">
                <ApplyFilterHeader />
            </div>
            <div className='row align-items-center pe-4 pb-2'>
                <div className='col-12 col-lg-9'>
                    <AmTabsHeader pageNo={pageNo} moremenu={performanceMenu} />
                </div>
            </div>
            <div className="sitesInfra_content contentWrap">
                <div className="sitePerformance_main row">
                    <div className="col-12 col-lg-4 sp_left">
                        <div className="box_card">
                            <div className="sp_left_content">
                                <h4 className="inf_heading label20 weight5 d-block heading_border_right pb-2">
                                    <span className="pe-2 bg_white">Summary</span>
                                </h4>

                                <table className="table st_summary_list mb-0">
                                    <tbody>
                                        <tr>
                                            <th className="label19 weight6">AMKM - 03</th>
                                            <th className="label19 weight6">Abbottabad</th>
                                        </tr>
                                        <tr>
                                            <td className="label16 weight4">Site Type</td>
                                            <td className="label16 weight5">BTS + HUB</td>
                                        </tr>
                                        <tr>
                                            <td className="label16 weight4">Site Category</td>
                                            <td className="label16 weight5">Host Sharing</td>
                                        </tr>

                                    </tbody>
                                </table>

                                <div className="d-flex justify-content-end border_bottom pb-2">
                                    <small className={styles.moreBtn}>View more <i><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                                        <path d="M12.6654 8.01497H3.33203" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.33203 11.349L12.6654 8.01562" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                        <path d="M9.33203 4.68164L12.6654 8.01497" stroke="#FF7F02" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg></i></small>
                                </div>

                                <div className='ssView_circleChart sp_circleChart border_bottom'>
                                    <div className='ssView_circleChart_cell'>
                                        <CircularProgressbarWithChildren value={100}>
                                            <div style={{ fontSize: 12, marginTop: -5 }}>
                                                <strong className='label16 weight6'>100%</strong>
                                            </div>
                                            <span className='color_gray_dark3 label14 weight4'>PAR</span>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    <div className='ssView_circleChart_cell strokeClr_pink'>
                                        <CircularProgressbarWithChildren value={99}>
                                            <div style={{ fontSize: 12, marginTop: -5 }}>
                                                <strong className='label16 weight6'>99%</strong>
                                            </div>
                                            <span className='color_gray_dark3 label14 weight4'>NAR</span>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                    <div className='ssView_circleChart_cell strokeClr_lBlue'>
                                        <CircularProgressbarWithChildren value={98}>
                                            <div style={{ fontSize: 12, marginTop: -5 }}>
                                                <strong className='label16 weight6'>98%</strong>
                                            </div>
                                            <span className='color_gray_dark3 label14 weight4'>TCH</span>
                                        </CircularProgressbarWithChildren>
                                    </div>
                                </div>

                                <div className="sp_calcPerformanceChart pt-2">
                                    <div className="ampButtonsGroup">
                                        <ul className="ampButtonsBox">
                                            <li>
                                                <span className="ampButton active">kWh</span>
                                            </li>
                                            <li>
                                                <span className="ampButton">Duty Cycle</span>
                                            </li>
                                        </ul>
                                    </div>
                                    <ReactECharts option={sp_calcTargets_data} opts={{ renderer: 'svg' }} style={{ height: 250 }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-8 sitePerf_right">
                        <div className="row">
                            {chartData.map((data, index) => (
                                <div className="pb-3 col-12 col-lg-6" key={data.id}>
                                    <div className="box_card">
                                        <div className="box_card_inner">
                                            <div className={`pws_box ${data.boxClass}`}>
                                                <div className="pws_head pb-3">
                                                    <div className="pws_head_title">
                                                        <i className='pws_head_icon' style={{ backgroundColor: data.actualColor }} key={index} dangerouslySetInnerHTML={{ __html: data.icon }} ></i>

                                                        <span>{data.title}</span>
                                                    </div>

                                                    <div className="pws_head_btn">
                                                        <span style={{ backgroundColor: data.titlebtnBgClr, color: data.titlebtnClr }}>{data.titlebtn}</span>
                                                    </div>
                                                </div>
                                                <div className="pws_content">
                                                    <div className="pws_values pb-3">
                                                        <ul>
                                                            <li>
                                                                <div className={`pw_values_box pws_has_arrow ${data.colorClass}`}>
                                                                    <small>{data.actualTitle}</small>
                                                                    <h2>
                                                                        <span>{data.actualValue}<sub>{data.actualType}</sub></span>
                                                                        <i>{data.actualPercent}</i>
                                                                    </h2>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <div className="pw_values_box">
                                                                    <small>{data.targetTitle}</small>
                                                                    <h2>
                                                                        <span>{data.targetValue}<sub>{data.targetType}</sub></span>
                                                                    </h2>

                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="pws_chart">
                                                        <SitePerfPowerSrcChart targetData={data.targetData} actualData={data.actualData} targetColor={data.targetColor} actualColor={data.actualColor} />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default SitesPerformance;